"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Phone, Mail, MapPin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-border/50 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-sm text-foreground hover:text-secondary transition-colors font-mono uppercase tracking-widest">
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-sm text-foreground hover:text-secondary transition-colors font-mono uppercase tracking-widest">
            About
          </Link>
        </li>
        <li data-index={2}>
          <Link to="#" className="text-sm text-foreground hover:text-secondary transition-colors font-mono uppercase tracking-widest">
            Services
          </Link>
        </li>
        <li data-index={3}>
          <Link to="#" className="text-sm text-foreground hover:text-secondary transition-colors font-mono uppercase tracking-widest">
            Contact
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-foreground hover:text-secondary transition-colors font-mono uppercase tracking-widest">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    label: "Instagram",
    href: "https://www.instagram.com/godfather_51222?igsh=MXJheXpsZzU4bHJlMg=="
  }];
  return <section data-section-id="264782" id="footer" className="bg-background text-foreground pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <Link to="/" className="inline-flex items-center mb-12">
          
        </Link>
        
        <div className="grid grid-cols-1 gap-10 justify-center w-full max-w-[1100px] mx-auto md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
          
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-flex items-center w-fit -m-2 p-2">
              <WvcLogo className="h-48 w-auto" />
            </Link>
            <p className="text-foreground leading-relaxed max-w-xs font-mono !text-2xl">Building Excellence Across Austin and the surrounding areas. Luxury Custom Homes, Remodeling &amp; New Construction.</p>
          </div>

          <div>
            <h3 className="font-default font-bold text-foreground text-lg mb-6 uppercase tracking-widest">Contact Us <br />Miguel Alonzo – Owner</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-base text-foreground font-mono flex-wrap">
                <Phone className="size-4 mt-0.5 shrink-0 text-primary" />
                <div className="flex flex-wrap gap-2">
                  <Button variant="outline" size="sm" asChild className="font-mono uppercase tracking-widest text-xs border-primary hover:bg-primary hover:text-primary-foreground rounded-md">
                    <Link to="tel:512-956-0639">Call Us</Link>
                  </Button>
                  <Button variant="outline" size="sm" asChild className="font-mono uppercase tracking-widest text-xs border-primary hover:bg-primary hover:text-primary-foreground rounded-md">
                    <Link to="sms:512-956-0639">Text Us</Link>
                  </Button>
                </div>
                <span className="w-full text-xs opacity-70">Mobile 512-956-0639</span>
              </li>
              <li className="flex items-start gap-3 text-base text-foreground font-mono flex-wrap">
                <Phone className="size-4 mt-0.5 shrink-0 text-primary" />
                <div className="flex flex-wrap gap-2">
                  <Button variant="outline" size="sm" asChild className="font-mono uppercase tracking-widest text-xs border-primary hover:bg-primary hover:text-primary-foreground rounded-md">
                    <Link to="tel:737-376-2987">Call Us</Link>
                  </Button>
                  <Button variant="outline" size="sm" asChild className="font-mono uppercase tracking-widest text-xs border-primary hover:bg-primary hover:text-primary-foreground rounded-md">
                    <Link to="sms:737-376-2987">Text Us</Link>
                  </Button>
                </div>
                <span className="w-full text-xs opacity-70">Office 737-376-2987</span>
              </li>
              <li className="flex items-start gap-3 text-base text-foreground font-mono">
                <Mail className="size-4 mt-0.5 shrink-0 text-primary" />
                <Link to="mailto:gfcllcs@gmail.com" className="hover:text-secondary transition-colors">
                  gfcllcs@gmail.com
                </Link>
              </li>
              <li className="flex items-start gap-3 text-base text-foreground font-mono">
                <MapPin className="size-4 mt-0.5 shrink-0 text-primary" />
                <span>Austin, Texas</span>
              </li>
            </ul>
          </div>

          

          <div className="!p-[5px]">
            <h3 className="font-default font-bold text-foreground mb-6 uppercase tracking-widest !text-sm !text-right !w-[140px]">Follow Us on instagram</h3>
            <div className="flex flex-wrap gap-2">
              {socialLinks.map((social, i) => {
              return <Button key={i} data-index={i} variant="outline" size="lg" asChild className="h-10 inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs px-6 has-[>svg]:px-4 bg-transparent border-primary transition-colors rounded-md !w-[140px] !h-[85px] border-1 border-solid !border-[rgba(52,40,35,0)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-primary hover:text-primary-foreground">
                    <Link to={social.href} aria-label={social.label} newTab>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-20">
                        <circle cx="12" cy="12" r="4" />
                        <path d="M17.5 6.5h.01" />
                        <rect width="20" height="20" x="2" y="2" rx="5" />
                      </svg>
                    </Link>
                  </Button>;
            })}
            </div>
          </div>

        </div>

        <Separator className="my-10 bg-border/20" />

        <div className="my-8 flex justify-center">
          <div className="w-full max-w-4xl aspect-[21/9] overflow-hidden rounded-lg flex items-center justify-center bg-secondary-foreground">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_luxury_home.png" alt="Austin Luxury Custom Home" className="h-full object-cover w-full max-w-[350px] !bg-transparent" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_luxury_home.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_luxury_home.png-wvc-sizes" loading="lazy" decoding="async" src="https://gfccontractors.com/wp-content/uploads/2026/08/965C0044_255A_4EA8_8356_9F1E6A6C18AC_12b02a00-5006-4079-92f7-2909e492b5ef.jpg" src="https://gfccontractors.com/wp-content/uploads/2026/07/ChatGPT-Image-Jul-23-2026-02_17_16-PM.png" />
          </div>
        </div>

        <div className="my-8 flex justify-center">
          <div className="w-full max-w-4xl aspect-[21/9] overflow-hidden rounded-lg bg-muted flex items-center justify-center">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_custom_remodel.png" alt="Austin Custom Remodel and Construction" className="w-full h-full object-cover" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_custom_remodel.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681426/img/austin_custom_remodel.png-wvc-sizes" loading="lazy" decoding="async" src="https://gfccontractors.com/wp-content/uploads/2026/08/965C0044_255A_4EA8_8356_9F1E6A6C18AC_12b02a00-5006-4079-92f7-2909e492b5ef.jpg" />
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-foreground font-mono uppercase tracking-widest">
          <p>© {currentYear}&nbsp;God Father Company. All rights reserved.</p>
          <div className="flex gap-6">
            <Link href="/privacy-policy/" className="hover:text-secondary transition-colors">
              Privacy Policy
            </Link>
            <Link href="/terms-of-service/" className="hover:text-secondary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}